import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PromiseBand } from './components/PromiseBand';
import { WhatIsIt } from './components/WhatIsIt';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Offer } from './components/Offer';
import { ForWhom } from './components/ForWhom';
import { Transformation } from './components/Transformation';
import { IncludedTable } from './components/IncludedTable';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="2wk0bn6p7uxy5">
      <Hero data-id="element-1" data-mp="2wip6p3k1bk5g" />
      <main data-id="element-2" data-mp="2wi5nzkmk8rqd">
        <PainPoints data-id="element-3" data-mp="28ufoebm15ej2" />
        <PromiseBand data-id="element-4" data-mp="28tmex2vosax8" />
        <WhatIsIt data-id="element-5" data-mp="28t4kmbsl46ry" />
        <Tomos data-id="element-6" data-mp="28sl511qepuh3" />
        <Bonos data-id="element-7" data-mp="28s2xh8yanttv" />
        <Offer data-id="element-8" data-mp="23vkw8j26adma" />
        <ForWhom data-id="element-9" data-mp="23vulg4fe8gqx" />
        <Transformation data-id="element-10" data-mp="23u9qidp62vsj" />
        <IncludedTable data-id="element-11" data-mp="23v2tr4ox335x" />
        <FinalCta data-id="element-12" data-mp="3ijxq4swlw4ky" />
      </main>
      <Footer data-id="element-13" data-mp="3ikqy1x7ax04o" />
      <StickyCta data-id="element-14" data-mp="3ij64a9st9l7v" />
    </div>;
}